import React from 'react';
import { AlarmStatusDataProvider } from '../../data/DataProviders/AlarmStatusDataProvider';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { TimelineListItem } from './TimelineListItem';
import { Props } from './types';

export const TimelineListItemContainer: React.FC<Props> = (props) => (
    <DataProviderCache for="Timeline status of every alarm">
        <AlarmStatusDataProvider alarmId={props.value.alarmId} deviceId={props.value.deviceId}>
            <TimelineListItem {...props} />
        </AlarmStatusDataProvider>
    </DataProviderCache>
);
